const RECIPE_DECIMAL_SCALE = 4;

export const formatRecipeDecimal = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const numericValue = Number(String(value).trim().replace(",", "."));
  if (!Number.isFinite(numericValue)) return "";

  return String(Number(numericValue.toFixed(RECIPE_DECIMAL_SCALE)));
};

export const sanitizeRecipeDecimalInput = (value) => {
  const rawValue = String(value ?? "");
  if (rawValue.includes("-")) return "";

  const cleanedValue = rawValue
    .replace(/,/g, ".")
    .replace(/[^\d.]/g, "");

  if (!cleanedValue) return "";

  const [rawInteger = "", ...rawDecimals] = cleanedValue.split(".");
  const integer = rawInteger.replace(/^0+(?=\d)/, "") || "0";
  if (!cleanedValue.includes(".")) return integer;

  const decimals = rawDecimals.join("").slice(0, RECIPE_DECIMAL_SCALE);
  return `${integer}.${decimals}`;
};

export const isPositiveRecipeDecimal = (value) => {
  if (value === null || value === undefined || value === "") return false;

  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0;
};
